var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.009,
    height: 36.009,
    viewBox: "0 0 36.009 36.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1259 -726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    transform: "translate(1259 726)",
    fill: "#dae0e7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1262.725 729.725)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.559,
    height: 28.559,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.666 7.291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.218,8.249,0,1.031,1.031,0,7.217,6.186,13.4,0l1.031,1.031L7.217,8.249Z",
    transform: "translate(0 14.436) rotate(-90)",
    fill: "#0d1c4b",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.44573abc08b04b811ae90814f3e82898.svg";
export { ForwardRef as ReactComponent };